// extracted by mini-css-extract-plugin
export default {"root":"ArticlesLayout_root__jIBFl","articlesLayout":"ArticlesLayout_articlesLayout__XL95c","footer":"ArticlesLayout_footer__W1ePc"};